module.exports = __webpack_public_path__ + "static/media/main_contactus.f06a88a6.png";